import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  igrejaModulosService,
  type ConfiguracaoModulo,
} from "@/core/services/igrejaModulosService";
import { useAuth } from "@/core/hooks/useAuth";

const QUERY_KEY_IGREJA_MODULOS = ["igreja-modulos"];

/** Configuração de módulos da igreja (tela /admin/modulos). */
export function useIgrejaModulos() {
  return useQuery({
    queryKey: QUERY_KEY_IGREJA_MODULOS,
    queryFn: igrejaModulosService.listar,
  });
}

export function useSalvarModulo() {
  const queryClient = useQueryClient();
  const { recarregarAcessos } = useAuth();
  return useMutation({
    mutationFn: ({ codigo, cfg }: { codigo: string; cfg: ConfiguracaoModulo }) =>
      igrejaModulosService.salvar(codigo, cfg),
    onSuccess: async () => {
      queryClient.invalidateQueries({ queryKey: QUERY_KEY_IGREJA_MODULOS });
      // O ministério responsável muda a seção "módulos" do detalhe do ministério.
      queryClient.invalidateQueries({ queryKey: ["ministerios"] });
      await recarregarAcessos();
    },
  });
}
